import React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

export default createSvgIcon(React.createElement(
  'g',
  null,
  React.createElement(
    'title',
    null,
    'Trace Icons_1-3'
  ),
  React.createElement('path', { d: 'M27,6.59H24.4V4.11H23.1V6.59H8.9V4.11H7.6V6.59H5A2.65,2.65,0,0,0,2.35,9.24v16A2.65,2.65,0,0,0,5,27.89H27a2.65,2.65,0,0,0,2.65-2.65v-16A2.65,2.65,0,0,0,27,6.59ZM5,7.89H27a1.35,1.35,0,0,1,1.35,1.35v2.47H3.65V9.24A1.35,1.35,0,0,1,5,7.89Zm22,18.7H5a1.36,1.36,0,0,1-1.35-1.35V13h24.7V25.24A1.36,1.36,0,0,1,27,26.59Z' }),
  React.createElement('path', { d: 'M14,15.57a2.84,2.84,0,0,0-2.86,3v2.07a2.87,2.87,0,1,0,5.74,0V18.61A2.85,2.85,0,0,0,14,15.57Zm1.65,5.11a1.65,1.65,0,1,1-3.28,0V18.61a1.65,1.65,0,1,1,3.28,0Z' }),
  React.createElement('polygon', { points: '17.51 16.92 19.1 16.92 19.1 23.61 20.32 23.61 20.32 15.7 18.44 15.7 17.51 16.92' }),
  React.createElement('g', { id: 'Artboard-32' })
));